import { Link } from 'react-router-dom';
import './dashboard.css';

export interface BreadcrumbSegment {
  label: string;
  /** Ausente en el último segmento — la pantalla actual nunca es un link. */
  to?: string;
}

/**
 * Breadcrumb simple de texto — "Inicio / Sistema de Transporte / Línea 500".
 * Sin lógica de ruta genérica: cada pantalla arma su propia lista corta de
 * segmentos, a propósito, para no construir un motor de breadcrumbs que
 * nadie pidió.
 */
export function PortalBreadcrumb({ segments }: { segments: BreadcrumbSegment[] }): JSX.Element {
  return (
    <nav className="db-breadcrumb" aria-label="Breadcrumb">
      {segments.map((segment, i) => (
        <span key={`${segment.label}-${i}`}>
          {i > 0 && <span aria-hidden="true"> / </span>}
          {segment.to ? (
            <Link to={segment.to}>{segment.label}</Link>
          ) : (
            <span className="db-breadcrumb-current">{segment.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
